"use client";

import styled from "styled-components";

//Components
import Input from "../input";
import Button from "@/components/button";
import icons from "@/assets/svg";

//Types
interface ButtonProps {
  onClick?: React.MouseEventHandler;
  icon?: keyof typeof icons;
}

export const InputGroupPassword = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 4px;
  }

  input {
    padding-right: 40px;
  }
`;

export const InputPassword = styled(Input)`
  font-size: 15px;
`;

export const ShowHiddendPassword = styled(Button)<ButtonProps>`
  background: transparent !important;
  padding: 0 !important;
  position: absolute;
  top: calc(24px + 4px + 20px);
  transform: translateY(-50%);
  right: 12px;
  border: none;
  height: 1em;
  min-height: 1em;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  z-index: 1;
  cursor: pointer;

  &:hover {
    background: transparent;
  }

  svg {
    fill: var(--textLight) !important;
    width: 1em;
    height: 1em;
    display: block;
  }
`;
